import _ from 'lodash';
import React from 'react';
import { widgetDefaultProps, widgetPropType } from '@glowforge/ui-common/models';
import FeaturesDisplay from './features-display';

import './features-display.less';

// Used to map Contentful content to this custom widget. See
// ui-common/contentful-widgets/
const FeaturesDisplayWidget = ({
  sections,
  model,
}) => {
  const displayTitle = _.get(model, 'textStrings.revolutionary-title');
  const seeMoreText = _.get(model, 'textStrings.media-card-swipe-to-see-more');
  const features = _.map(sections, ({ fields: { title, text, images } }) => ({
    title,
    text,
    media: images[0],
  }));
  return (
    <FeaturesDisplay title={displayTitle} seeMoreText={seeMoreText} features={features} />
  );
};

FeaturesDisplayWidget.propTypes = widgetPropType;

FeaturesDisplayWidget.defaultProps = widgetDefaultProps;

export default FeaturesDisplayWidget;
